/**
 * @generated SignedSource<<6f6ebce7611cd1e466e5a0811c0872a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SalesChannelDetailInput = {
  id?: string | null;
  properties?: SalesChannelDetailPropertiesInput | null;
  salesChannelGlobalID?: string | null;
  userID?: number | null;
};
export type SalesChannelDetailPropertiesInput = {
  name?: string | null;
};
export type renameSalesChannelDialogMutation$variables = {
  input: SalesChannelDetailInput;
};
export type renameSalesChannelDialogMutation$data = {
  readonly upsertSalesChannelDetail: {
    readonly id: string;
    readonly properties: {
      readonly name: string | null;
    } | null;
  };
};
export type renameSalesChannelDialogMutation = {
  response: renameSalesChannelDialogMutation$data;
  variables: renameSalesChannelDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SalesChannelDetail",
    "kind": "LinkedField",
    "name": "upsertSalesChannelDetail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesChannelDetailProperties",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "renameSalesChannelDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "renameSalesChannelDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d5d5410755251872ac969314204f98d",
    "id": null,
    "metadata": {},
    "name": "renameSalesChannelDialogMutation",
    "operationKind": "mutation",
    "text": "mutation renameSalesChannelDialogMutation(\n  $input: SalesChannelDetailInput!\n) {\n  upsertSalesChannelDetail(input: $input) {\n    id\n    properties {\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ffa5e6aaadcfd2027fd9f1342bc9a7b";

export default node;
